module.exports = __webpack_public_path__ + "img/img-c8d01c.png";